import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const BrandMark = () => (
  <svg width="36" height="36" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="1" width="38" height="38" rx="2" stroke="#0a1628" strokeWidth="1.5"/>
    <path d="M8 30 L15 14 L20 24 L25 10 L32 30" stroke="#c05a34" strokeWidth="2" strokeLinecap="square" strokeLinejoin="miter" fill="none"/>
    <circle cx="32" cy="10" r="2.5" fill="#c05a34"/>
  </svg>
);

export default function ThankYou() {
  useEffect(() => {
    document.title = 'Argenergia — Gracias por su mensaje';
    document.documentElement.lang = 'es-AR';
  }, []);

  return (
    <div className="thankyou-shell">
      <Link to="/" className="thankyou-brand">
        <BrandMark />
        <span>Argenergia</span>
      </Link>

      <div className="thankyou-body">
        <div className="thankyou-mark" aria-hidden>✓</div>
        <h1>¡Gracias por su mensaje!</h1>
        <p>
          Hemos recibido su consulta correctamente. Nuestro equipo analítico se pondrá en
          contacto en el próximo día hábil desde la casilla contacto@argenergia.com.
        </p>
        <p>
          Mientras tanto, puede explorar nuestros reportes públicos sobre Vaca Muerta y el
          Triángulo del Litio.
        </p>
        <Link to="/" className="btn-primary" data-testid="thankyou-back-home">
          Volver al inicio <span aria-hidden>→</span>
        </Link>
      </div>
    </div>
  );
}
